/**
 * Utility functions for Shopify cookie management
 */

export const SHOPIFY_VISITOR_COOKIE = '_shopify_y';
export const SHOPIFY_SESSION_COOKIE = '_shopify_s';

/**
 * Check if Shopify analytics cookies exist
 */
export function hasShopifyCookies(): boolean {
  if (typeof document === 'undefined') return false;

  try {
    // Use getCookieValue to ensure exact cookie name matching
    const visitorCookie = getCookieValue(SHOPIFY_VISITOR_COOKIE);
    const sessionCookie = getCookieValue(SHOPIFY_SESSION_COOKIE);

    return visitorCookie !== null && sessionCookie !== null;
  } catch (_error) {
    // Return false if cookie access fails (e.g., in restricted environments)
    return false;
  }
}

/**
 * Get a specific cookie value
 */
export function getCookieValue(name: string): string | null {
  if (typeof document === 'undefined') return null;

  try {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() || null;
    }
    return null;
  } catch (_error) {
    return null;
  }
}

/**
 * Check if cookies are enabled in the browser
 */
export function areCookiesEnabled(): boolean {
  if (typeof document === 'undefined') return false;

  try {
    // Try to set a test cookie
    // biome-ignore lint/nursery/noDocumentCookie: <explanation>
    document.cookie = 'testcookie=1';
    const cookieEnabled = getCookieValue('testcookie') === '1';

    // Clean up test cookie
    if (cookieEnabled) {
      // biome-ignore lint/nursery/noDocumentCookie: <explanation>
      document.cookie = 'testcookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
    }

    return cookieEnabled;
  } catch (_error) {
    // Return false if cookie access fails (e.g., in restricted environments)
    return false;
  }
}
